import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-do-export-excel',
  templateUrl: './do-export-excel.component.html',
  styleUrl: './do-export-excel.component.scss',
  standalone: false,
})
export class DoExportExcelComponent extends BaseComponent {
  menuItems: MenuItem[] = [];

  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
    this.menuItems = [
      {
        label: 'Export Items',
        command: () => this.onExportExcel(),
      },
      {
        label: 'Export Test Steps',
        command: () => this.onExportTestStepsExcel(),
      },
    ];
  }

  public onExportExcel(): void {
    this.toolbarEventManagerHelper.DoToolbarExportExcel = true;
  }

  public onExportTestStepsExcel(): void {
    this.toolbarEventManagerHelper.DoToolbarExportTestStepExcel = true;
  }
}
